<template>
  <div class="vip-detail-wrap vip-background-image">
    <div class="main">
      <!-- 直播页的头部信息 -->
      <YVipHeader />
      <!-- 公用导航 -->
      <YNav />
      <!-- 主要内容 -->
      <YDetailClass />
    </div>
  </div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import YVipHeader from '@/components/vip/Header'
import YNav from '@/components/Nav'
import YDetailClass from '@/components/vip/DetailClass'

export default {
  name: 'vip-detail',
  scrollToTop: true,
  validate ({ params }) {
    return params.id > 0
  },
  async asyncData ({ params, store, error, redirect }) {
    let teacher = await store.dispatch('teacher/getInfo', params.id)
    if (!teacher) {
      error({ statusCode: 404, message: '该老师不存在' })
      return
    }
    if (!teacher.trainingId) {
      redirect('/vip/edit')
      return
    }
    if (store.state.user.data) {
      await store.dispatch('vip/initVipRoomData', { id: teacher.trainingId })
    }
    return {
      teacher
    }
  },
  head () {
    return {
      title: `${this.teacher.userName}-特训班-一富财经—打造中国最靠谱的的投资者教育平台,股市直播,股票交流`
    }
  },
  mounted () {
    if (!this.$isLogin()) {
      Dialog.login()
    }
  },
  components: {
    YVipHeader,
    YNav,
    YDetailClass
  }
}
</script>
